import React from 'react';
import {
    css,
    Header,
    Div,
    Icon,
} from "@bdfx/fukit"
import ResultLine from "./result-line"
import { getColor } from '../helpers'
import ctrans from "../../common/trans"
import trans from '../trans';


const Results = ({ auditId, errors = {}, warnings = {}, suggestions = {}, total, deleted }) => {
    const emptyErrors = Object.keys(errors).filter(e => errors[e] === 0)
    const emptyWarnings = Object.keys(warnings).filter(e => warnings[e] === 0)
    const emptySuggestions = Object.keys(suggestions).filter(e => suggestions[e] === 0)

    const nullErrors = Object.keys(errors).filter(e => errors[e] === null)
    const nullWarnings = Object.keys(warnings).filter(e => warnings[e] === null)
    const nullSuggestions = Object.keys(suggestions).filter(e => suggestions[e] === null)
    const nulls = [...nullErrors, ...nullWarnings, ...nullSuggestions]


    return <ResultsSection className="content section">
        <div>
            {Object.keys(errors).length > 0 ? <div>
                <ContentHeader>{ctrans("errors")}</ContentHeader>
                <section>
                    {Object.keys(errors).filter(e => errors[e] > 0).map(e => <ResultLine key={e} deleted={deleted} auditId={auditId} index={e} count={errors[e]} total={total} type="error" background={getColor("bidding_group_problems")} />)}
                </section>
                {emptyErrors.length > 0 ?
                    <Empty className="empty npbreak">
                        <Header type={4}>{ctrans("checks_all_right")}:</Header>
                        {emptyErrors.map(e => <Div key={e}><Icon color="#69A120" size={30} type="check-slim">{trans(e)}</Icon></Div>)}
                    </Empty>
                : null}

            </div> : null}
            {Object.keys(warnings).length > 0 ? <div>
                <ContentHeader>{ctrans("warnings")}</ContentHeader>
                <section>
                    {Object.keys(warnings).filter(e => warnings[e] > 0).map(e => <ResultLine key={e} deleted={deleted} auditId={auditId} index={e} count={warnings[e]} total={total} type="warning" background={getColor("bidding_group_warnings")} />)}
                </section>
                {emptyWarnings.length > 0 ?
                    <Empty className="empty npbreak">
                        <Header type={4}>{ctrans("checks_all_right")}:</Header>
                        {emptyWarnings.map(e => <Div key={e}><Icon color="#69A120" size={30} type="check-slim">{trans(e)}</Icon></Div>)}
                    </Empty>
                : null}
            </div> : null}
            {Object.keys(suggestions).length > 0 ? <div>
                <ContentHeader>{ctrans("suggestions")}</ContentHeader>
                <section>
                 {Object.keys(suggestions).filter(e => suggestions[e] > 0).map(e => <ResultLine key={e} deleted={deleted} auditId={auditId} index={e} count={suggestions[e]} total={total} type="suggestion" background={getColor("bidding_group_recommendations")} />)}
                </section>
                {emptySuggestions.length > 0 ?
                    <Empty  className="empty npbreak">
                        <Header type={4}>{ctrans("checks_all_right")}:</Header>
                        {emptySuggestions.map(e => <Div key={e}><Icon color="#69A120" size={30} type="check-slim">{trans(e)}</Icon></Div>)}
                    </Empty>
                : null}
            </div> : null}

            {nulls.length > 0 ?
            <div>
                <ContentHeader>{ctrans("cant_check")}</ContentHeader>
                <Empty style={{padding: "20px 0"}} className="empty npbreak">
                    <Header type={4}>{ctrans("missing_source_feed")}:</Header>
                    {nulls.filter(e => e !== "my_price_below_purchase_price" &&  e !== "competitors_below_purchase_price").map(e => <Div><Icon color="gray" size={30} type="close-light">{trans(e)}</Icon></Div>)}
                </Empty>
            </div>
            : null}
        </div>
        </ResultsSection>
}

const Empty = css("div")({
    borderTop: "1px solid #ddd",
    margin: "0 0px 0 0",
    padding: "20px 200px",
    ".fuk-header": {
        marginTop: "0",
        marginBottom: "1em",
    },
    ".fuk-icon": {
        gridGap: "20px",
        fontSize: "1.5rem",
    },
    "@media only screen and (max-width: 1000px)": {
        margin: "5px 20px !important",
    },
})

const ResultsSection = css("div")({
    minHeight: "100vh",
    background: "#fff",
    textAlign: "left",
    paddingBottom: "150px",
    "> div": {
        position: "relative",
        zIndex: 1,
        maxWidth: "1200px",
        margin: "auto",
    },
})
  
const ContentHeader = css(Header)({
    textAlign: "center",
})

export default Results